// global.js — Beauty Charms shared behaviour
document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Scroll reveal animations ---------- */
  const animatedEls = document.querySelectorAll('[data-bc-animate]');
  if ('IntersectionObserver' in window && animatedEls.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    animatedEls.forEach((el) => observer.observe(el));
  } else {
    animatedEls.forEach((el) => el.classList.add('is-visible'));
  }

  /* ---------- Search drawer ---------- */
  const searchOpenBtns = document.querySelectorAll('[data-bc-search-open]');
  const searchDrawer = document.getElementById('bc-search-drawer');
  if (searchDrawer) {
    searchOpenBtns.forEach((btn) => btn.addEventListener('click', () => {
      searchDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      const input = searchDrawer.querySelector('[data-bc-predictive-search-input]');
      if (input) setTimeout(() => input.focus(), 200);
    }));
    searchDrawer.querySelectorAll('[data-bc-search-close]').forEach((el) => el.addEventListener('click', () => {
      searchDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }));
  }

  /* ---------- Cart drawer ---------- */
  const cartOpenBtns = document.querySelectorAll('[data-bc-cart-open]');
  const cartDrawer = document.getElementById('bc-cart-drawer');
  if (cartDrawer) {
    cartOpenBtns.forEach((btn) => btn.addEventListener('click', () => {
      cartDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }));
    cartDrawer.querySelectorAll('[data-bc-cart-close]').forEach((el) => el.addEventListener('click', () => {
      cartDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }));
  }

  /* ---------- Escape key closes any open drawer ---------- */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.is-open').forEach((el) => el.classList.remove('is-open'));
    document.body.style.overflow = '';
  });
});
